// extracted by mini-css-extract-plugin
export default {"propGrid":"LearningContentProp_propGrid__LKQ4p","propCard":"LearningContentProp_propCard__RhRSb","propTitle":"LearningContentProp_propTitle__K4Ee9"};